"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var findRootLayout_exports = {};
__export(findRootLayout_exports, {
  findRootLayout: () => findRootLayout
});
module.exports = __toCommonJS(findRootLayout_exports);
function findRootLayout(routes, routerRoot) {
  var exactKey = `/${routerRoot}/_layout.tsx`;
  if (routes[exactKey]) return routes[exactKey]();
  for (var _i = 0, _iter = [
    "+ssg",
    "+ssr",
    "+spa"
  ]; _i < _iter.length; _i++) {
    var suffix = _iter[_i];
    var key = `/${routerRoot}/_layout${suffix}.tsx`;
    if (routes[key]) return routes[key]();
  }
  var exactKeyTs = `/${routerRoot}/_layout.ts`;
  if (routes[exactKeyTs]) return routes[exactKeyTs]();
  for (var _i1 = 0, _iter1 = [
    "+ssg",
    "+ssr",
    "+spa"
  ]; _i1 < _iter1.length; _i1++) {
    var suffix1 = _iter1[_i1];
    var key1 = `/${routerRoot}/_layout${suffix1}.ts`;
    if (routes[key1]) return routes[key1]();
  }
  return void 0;
}
//# sourceMappingURL=findRootLayout.js.map
